import React from 'react';
import { Input, Checkbox, Button } from 'antd'; // Removed DatePicker as it's not directly used here
import { CloseOutlined } from '@ant-design/icons';
import { handleImpactActualUpdateCheckFilter } from './actualImpactUpdateCheck';
import DateFilterComponent from './DateFilterComponent'; // Keep this for date filters

export const handleImpactCurrentFilter = (
  impactCurrentFilter,
  initiatives,
  attributeFilters,
  setAttributeFilters,
  searchTerm,
  setSearchTerm,
  workstreams,
  subsectors
) => {
  const updateAttributeFilters = (newValue) => {
    setAttributeFilters({
      ...attributeFilters,
      [impactCurrentFilter]: newValue,
    });
  };

  const handleClearFilters = () => {
    setAttributeFilters({});
    setSearchTerm(''); // Clear search term when filters are cleared
  };
  if (
    impactCurrentFilter === 'Actual impact update check (for last completed and previous period)'
  ) {
    return (
      <>
        {Object.keys(attributeFilters).length > 0 && (
          <Button
            icon={<CloseOutlined />}
            onClick={handleClearFilters}
            style={{ marginBottom: '10px', color: 'blue' }}
          >
            Clear Filters
          </Button>
        )}
        {handleImpactActualUpdateCheckFilter(
          impactCurrentFilter,
          attributeFilters,
          setAttributeFilters
        )}
      </>
    );
  }

  if (
    impactCurrentFilter === 'Planned value last update date (calendarized impact)' ||
    impactCurrentFilter === 'Actual value last update date (calendarized impact)'
  ) {
    return (
      <>
        {Object.keys(attributeFilters).length > 0 && (
          <Button
            icon={<CloseOutlined />}
            onClick={handleClearFilters}
            style={{ marginBottom: '10px' }}
          >
            Clear Filters
          </Button>
        )}
        <DateFilterComponent
          currentFilter={impactCurrentFilter}
          attributeFilters={attributeFilters}
          setAttributeFilters={setAttributeFilters}
        />
      </>
    );
  }

  // --- "Whose P&L does this impact?" Filter ---
  if (impactCurrentFilter === 'Whose P&L does this impact?') {
    const uniqueOwners = [
      ...new Set(initiatives.flatMap((i) => i.impact?.map((imp) => imp.workstream) || [])),
    ];

    const ownerNames = uniqueOwners.map((ownerId) => {
      const user = workstreams.find((user) => user._id === ownerId);
      return user ? user.subworkstreamName : ownerId;
    });

    const allSelected =
      attributeFilters[impactCurrentFilter] === undefined ||
      attributeFilters[impactCurrentFilter]?.length === ownerNames.length;

    return (
      <div style={{ marginTop: '10px' }}>
        {Object.keys(attributeFilters).length > 0 && (
          <Button
            icon={<CloseOutlined />}
            onClick={handleClearFilters}
            style={{ marginBottom: '10px' }}
          >
            Clear Filters
          </Button>
        )}
        <Input
          placeholder="Search Owners"
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm} // Control the input value
          style={{ marginBottom: '10px' }}
        />
        <Checkbox
          indeterminate={
            attributeFilters[impactCurrentFilter]?.length > 0 &&
            attributeFilters[impactCurrentFilter]?.length < ownerNames.length
          }
          checked={allSelected}
          onChange={(e) => {
            updateAttributeFilters(e.target.checked ? ownerNames : []);
          }}
        >
          (Select all)
        </Checkbox>

        {ownerNames
          .filter((item) => String(item).toLowerCase().includes(searchTerm.toLowerCase()))
          .map((item) => (
            <div key={item}>
              <Checkbox
                checked={
                  attributeFilters[impactCurrentFilter] === undefined ||
                  attributeFilters[impactCurrentFilter]?.includes(item)
                }
                onChange={(e) => {
                  const currentFilters = attributeFilters[impactCurrentFilter] || [];
                  updateAttributeFilters(
                    e.target.checked
                      ? [...currentFilters, item]
                      : currentFilters.filter((val) => val !== item)
                  );
                }}
              >
                {String(item)}
              </Checkbox>
            </div>
          ))}
      </div>
    );
  }
  if (impactCurrentFilter === 'sector') {
    const ownerNames = [
      ...new Set(
        initiatives.flatMap((i) =>
          (i.impact || [])
            .map((imp) => {
              const sector = subsectors.find((s) => s._id === imp?.subsector);
              return sector ? sector?.sector?.sectorName : '<not set>';
            })
            .filter(Boolean)
        )
      ),
    ];

    const allSelected =
      attributeFilters[impactCurrentFilter] === undefined ||
      attributeFilters[impactCurrentFilter]?.length === ownerNames.length;

    return (
      <div style={{ marginTop: '10px' }}>
        {Object.keys(attributeFilters).length > 0 && (
          <Button
            icon={<CloseOutlined />}
            onClick={handleClearFilters}
            style={{ marginBottom: '10px' }}
          >
            Clear Filters
          </Button>
        )}

        <Input
          placeholder="Search sectors"
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
          style={{ marginBottom: '10px' }}
        />

        <Checkbox
          indeterminate={
            attributeFilters[impactCurrentFilter]?.length > 0 &&
            attributeFilters[impactCurrentFilter]?.length < ownerNames.length
          }
          checked={allSelected}
          onChange={(e) =>
            updateAttributeFilters(e.target.checked ? ownerNames : [])
          }
        >
          (Select all)
        </Checkbox>

        {ownerNames
          .filter((item) =>
            item.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((item) => (
            <div key={item}>
              <Checkbox
                checked={
                  attributeFilters[impactCurrentFilter] === undefined ||
                  attributeFilters[impactCurrentFilter]?.includes(item)
                }
                onChange={(e) => {
                  const current = attributeFilters[impactCurrentFilter] || [];
                  updateAttributeFilters(
                    e.target.checked
                      ? [...current, item]
                      : current.filter((v) => v !== item)
                  );
                }}
              >
                {item}
              </Checkbox>
            </div>
          ))}
      </div>
    );
  }

  if (impactCurrentFilter === 'subsector') {
    const ownerNames = [
      ...new Set(
        initiatives.flatMap((i) =>
          (i.impact || [])
            .map((imp) => {
              const subsector = subsectors.find(
                (s) => s._id === imp?.subsector
              );
              return subsector ? subsector?.subsectorName : '<not set>';
            })
            .filter(Boolean)
        )
      ),
    ];

    const allSelected =
      attributeFilters[impactCurrentFilter] === undefined ||
      attributeFilters[impactCurrentFilter]?.length === ownerNames.length;

    return (
      <div style={{ marginTop: '10px' }}>
        {Object.keys(attributeFilters).length > 0 && (
          <Button
            icon={<CloseOutlined />}
            onClick={handleClearFilters}
            style={{ marginBottom: '10px' }}
          >
            Clear Filters
          </Button>
        )}

        <Input
          placeholder="Search Subsectors"
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
          style={{ marginBottom: '10px' }}
        />

        <Checkbox
          indeterminate={
            attributeFilters[impactCurrentFilter]?.length > 0 &&
            attributeFilters[impactCurrentFilter]?.length < ownerNames.length
          }
          checked={allSelected}
          onChange={(e) =>
            updateAttributeFilters(e.target.checked ? ownerNames : [])
          }
        >
          (Select all)
        </Checkbox>

        {ownerNames
          .filter((item) =>
            item.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((item) => (
            <div key={item}>
              <Checkbox
                checked={
                  attributeFilters[impactCurrentFilter] === undefined ||
                  attributeFilters[impactCurrentFilter]?.includes(item)
                }
                onChange={(e) => {
                  const current = attributeFilters[impactCurrentFilter] || [];
                  updateAttributeFilters(
                    e.target.checked
                      ? [...current, item]
                      : current.filter((v) => v !== item)
                  );
                }}
              >
                {item}
              </Checkbox>
            </div>
          ))}
      </div>
    );
  }
  // Default filter handler for other impact attributes (including 'impactNumber')
  const allImpactValues = initiatives.flatMap(
    (i) => i.impact?.map((imp) => imp[impactCurrentFilter]) || []
  );

  const uniqueValuesWithEmptyCheck = [...new Set(allImpactValues)];

  // Check if any initiative has no impact or an empty impact array
  const hasNoImpact = initiatives.some((i) => !i.impact || i.impact.length === 0);

  // Add "<not set>" as a unique value if any initiative has no impact
  const uniqueValues = hasNoImpact
    ? [...uniqueValuesWithEmptyCheck, '<not set>']
    : uniqueValuesWithEmptyCheck;

  // --- Logic for displaying a limited number of items and enabling search ---
  const DISPLAY_LIMIT = 60; // Define the number of items to display initially

  const filteredValues = uniqueValues.filter((item) =>
    String(item).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const displayedValues = searchTerm
    ? filteredValues // If searching, show all matching results
    : filteredValues.slice(0, DISPLAY_LIMIT); // Otherwise, show only the first DISPLAY_LIMIT

  const allSelected =
    attributeFilters[impactCurrentFilter] === undefined ||
    attributeFilters[impactCurrentFilter]?.length === uniqueValues.length; // Still check against all unique values for "Select all"

  return (
    <div style={{ marginTop: '10px' }}>
      <Input
        placeholder="Search"
        onChange={(e) => setSearchTerm(e.target.value)}
        value={searchTerm} // Control the input value
        style={{ marginBottom: '10px' }}
      />
      {Object.keys(attributeFilters).length > 0 && (
        <Button
          icon={<CloseOutlined />}
          onClick={handleClearFilters}
          style={{ marginBottom: '10px', color: 'blue' }}
        >
          Clear Filters
        </Button>
      )}
      <Checkbox
        indeterminate={
          attributeFilters[impactCurrentFilter]?.length > 0 &&
          attributeFilters[impactCurrentFilter]?.length < uniqueValues.length
        }
        checked={allSelected}
        onChange={(e) => {
          updateAttributeFilters(e.target.checked ? uniqueValues : []); // Select/Deselect all unique values
        }}
      >
        (Select all)
      </Checkbox>

      {/* Render the displayed values */}
      {displayedValues.map((item) => (
        <div key={item}>
          <Checkbox
            checked={
              attributeFilters[impactCurrentFilter] === undefined ||
              attributeFilters[impactCurrentFilter]?.includes(item)
            }
            onChange={(e) => {
              const currentFilters = attributeFilters[impactCurrentFilter] || [];
              updateAttributeFilters(
                e.target.checked
                  ? [...currentFilters, item]
                  : currentFilters.filter((val) => val !== item)
              );
            }}
          >
            {String(item)}
          </Checkbox>
        </div>
      ))}

      {/* Show message if there are more items not displayed */}
      {!searchTerm && uniqueValues.length > DISPLAY_LIMIT && (
        <p style={{ marginTop: '10px', fontSize: '0.85em', color: '#888' }}>
          Displaying first {DISPLAY_LIMIT} items. Use search to find more.
        </p>
      )}
    </div>
  );
};